package com.milta.feature.legal.domain.entity

/**
 * GET /api/v1/legal-documents/{type} — public endpoint, no auth required (backend repo, out of
 * scope here). [content] is plain text, paragraphs separated by a blank line (`\n\n`) — never
 * HTML/Markdown to interpret. Only French exists server-side for now: the backend silently falls
 * back to French regardless of the requested `lang` until the other 9 languages are filled in.
 */
data class LegalDocument(
    val title: String,
    val content: String,
    val updatedAt: String,
)
